import _ from 'lodash';
import strings from 'app/strings';
import * as actions from 'app/common/actions/common';

function extractCustomGlobalPromiseError(error) {
  if (_.isNil(error)) {
    return null;
  }
  // This is a generic Error and was not raised with customer promise error
  // We show just a generic message for it.
  if (!error.type) {
    return strings.NOTIFICATION_LEVEL_ERROR_TEXT;
  }
  const message = error.message;
  if (!_.isString(message) || _.isEmpty(message)) {
    return strings.NOTIFICATION_LEVEL_ERROR_TEXT;
  }
  return message;
}

/**
 * Common Reducer store for items such as user info and elements present accross pages
 */
export default function(state = {}, action) {
  switch (action.type) {
    case actions.PROMISE_ERROR: {
      return Object.assign({}, state, {
        noticeLevelError: extractCustomGlobalPromiseError(action.error),
      });
    }
    case actions.SET_CATEGORIES: {
      return Object.assign({}, state, {
        shopCategories: _.get(action, 'result.shop') ? _.get(action, 'result.shop') : state.shopCategories,
        designCategories: _.get(action, 'result.catalog') ? _.get(action, 'result.catalog') : state.designCategories,
      });
    }
    case actions.SET_USER: {
      return Object.assign({}, state, {
        user: _.get(action, 'result'),
      });
    }
    case actions.SET_FEATURE_FLAGS: {
      return Object.assign({}, state, {
        features: _.get(action, 'result'),
      });
    }
    case actions.SET_GLOBAL_FOOTER: {
      return Object.assign({}, state, { footer: _.get(action, 'result') });
    }
    case actions.SET_COOKIE_NOTIFICATION: {
      return Object.assign({}, state, { cookieNotification: _.get(action, 'result') });
    }
    case actions.SET_DEFAULT_METADATA: {
      return Object.assign({}, state, {
        defaultMetadata: _.get(action, 'result'),
      });
    }
    case actions.SET_MACHINES: {
      return Object.assign({}, state, {
        machines: _.get(action, 'result.machines'),
        machinesLoading: false,
      });
    }
    case actions.MACHINES_LOADING: {
      return Object.assign({}, state, {
        machinesLoading: true,
      });
    }
    case actions.UPDATE_PROFILE: {
      return { ...state, user: action.result };
    }
    case actions.UPDATE_PROFILE_ERROR: {
      return { ...state, errors: action.result };
    }
    case actions.UPDATE_USER: {
      let userSubmitError;
      if (_.get(action, 'result.status') === 'error') {
        userSubmitError = strings.GENERIC_SUBMIT_ERROR; // TODO: more specific error handling?
      }
      return Object.assign({}, state, {
        user: _.get(action, 'result.user'),
        userSubmitError,
      });
    }
    case actions.VALIDATION_COMPLETE: {
      return Object.assign({}, state, {
        showConfirmDialog: false,
        validPostalAddress: null,
      });
    }
    case actions.SET_VALIDATED_POSTAL_INFO: {
      const output = {
        showConfirmDialog: false,
      };
      if (_.get(action, 'result.status') === 'success'
        && _.get(action, 'result.validPostalAddress')) {
        output.showConfirmDialog = true;
        output.validPostalAddress = _.get(action, 'result.validPostalAddress');
        if (_.get(action, 'result.user')) output.user = _.get(action, 'result.user');
      } else if (_.get(action.result, 'errors.invalidPostalAddress')) {
        output.submitError = _.get(action.result, 'errors.invalidPostalAddress')[0];
      } else {
        output.submitError = strings.GENERIC_SUBMIT_ERROR;
      }

      return Object.assign({}, state, output);
    }
    // TODO: This should be merged in with the above SET_VALIDATED_POSTAL_INFO endpoint
    // Right now the shipping info end point also sets address as primary shipping address
    case actions.SET_SHIPPING_INFO_SUCCESS: {
      const output = {
        showConfirmDialog: false,
      };
      if (_.get(action, 'result.status') === 'success'
        && _.get(action, 'result.validPostalAddress')) {
        output.showConfirmDialog = true;
        output.validPostalAddress = _.get(action, 'result.validPostalAddress');
      } else if (_.get(action.result, 'errors.invalidPostalAddress')) {
        output.submitError = _.get(action.result, 'errors.invalidPostalAddress')[0];
      } else {
        output.submitError = strings.GENERIC_SUBMIT_ERROR;
      }

      return Object.assign({}, state, output);
    }
    case actions.SET_SHIPPING_INFO_ERROR: {
      return Object.assign({}, state, {
        errors: _.get(action, 'result'),
      });
    }
    case actions.CONFIRM_ADDRESS_VERIFY:
    case actions.CANCEL_ADDRESS_VERIFY: {
      return Object.assign({}, state, {
        showConfrimDialog: false,
        validPostalAddress: null,
        submitError: null,
      });
    }
    case actions.SET_ADDRESS_STATES: {
      const newAddressStatesList = Object.assign({}, state.addressStates, {
        [action.result.country]: action.result,
      });

      return Object.assign({}, state, {
        addressStates: newAddressStatesList,
      });
    }
    case actions.SET_ADDRESS_COUNTRIES: {
      return Object.assign({}, state, {
        addressCountries: _.get(action, 'result.countries'),
      });
    }
    case actions.SET_WARRANTY_PAGE: {
      return Object.assign({}, state, {
        warrantyPage: action.result,
      });
    }
    case actions.SET_NO_GLOWFORGE_PAGE: {
      return Object.assign({}, state, {
        noGlowforgePage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_EMAIL_CAPTURE_STATUS: {
      const emailSuccess = _.get(action, 'result.status') === 'success';
      const emailError = !emailSuccess;
      return Object.assign({}, state, { emailSuccess, emailError });
    }
    case actions.SET_REFERRAL_INFO: {
      return Object.assign({}, state, {
        referral: action.result,
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/common/reducers/common.js